import { http } from '@/utils/http';
import qs from 'qs';

// 报名
export function saveData(data: any) {
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/2019poject/2019breakthelimitone/controller.php?enews=save',
    qsData,
  );
}
// 活动规则
export function getRules() {
  return http.get(
    '/vote/2019poject/2019breakthelimitone/controller.php?enews=rules',
  );
}
